import { NgModule } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { AuthGuardService } from 'app/shared/auth-guard.service';
import { canDeactivateGuard } from 'app/shared/can-deactivate-guard.service';
import { EntityManagerProviderGuard } from 'app/shared/entity-manager-guard';
import { SharedModule } from 'app/shared/shared.module';
import { AccountFinderDialogComponent } from './account-finder-dialog.component';
import { AccountComponent } from './account.component';
import { AppConfigDialogComponent } from './app-config-dialog.component';
import { EditAccountDialogComponent } from './edit-account-dialog.component';
import { QboCustomerLinkDialogComponent } from './qbo-customer-link-dialog.component';
import { QbAuditComponent } from './qb-audit.component';
import { QboTestComponent } from './qbo-test.component';
import { UserAccountDialogComponent } from './user-account-dialog.component';
import { UserAccountsComponent } from './user-accounts.component';
import { TextboxDialogComponent } from '@/shared/textbox-dialog.component';
import { TextPromptDialogComponent } from '@/shared/text-prompt-dialog.component';
import { JobOrderFinderDialogComponent } from './job-order-finder-dialog.component';
import { RestockFeeDialogComponent } from './restock-fee-dialog.component';
import { RestockFeeInvoiceComponent } from './restock-fee-invoice.component';
import { RestockFeePrintableComponent } from './restock-fee-printable.component';
import { QbConfigComponent } from './qb-config.component';
import { AdministrationManagerComponent } from './administration-manager.component';
import { OrderAnalysisComponent } from './order-analysis.component';
import { QbSubmissionComponent } from '../home/qb-submission.component';
import { ProximityApiComponent } from '../home/proximity-api.component';
import { NotificationTemplateListComponent } from '../notifications/notification-template-list.component';
import { HangfireJobsComponent } from './hangfire-jobs.component';
import { AutoNotesCatalogDocComponent } from './auto-notes-catalog-doc.component';
import { UnwindAndReconciliationDocComponent } from './unwind-and-reconciliation-doc.component';
import { EnableAccountInventoryComponent } from './enable-account-inventory.component';
import { StrandedOrdersComponent } from './stranded-orders.component';
import { StagedFeedComponent } from './staged-feed.component';
import { BulkRepointColorDialogComponent } from './bulk-repoint-color-dialog.component';
import { BulkRetireDialogComponent } from './bulk-retire-dialog.component';

export const routes = [
  {
    path: 'administration/manage',
    component: AdministrationManagerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { breadcrumb: 'Administration' },
    children: [
      {
        path: '',
        redirectTo: 'gl-submission',
        pathMatch: 'full',
      },
      {
        path: 'gl-submission',
        component: QbSubmissionComponent,
        canDeactivate: [canDeactivateGuard],
        data: { breadcrumb: 'GL Submissions' },
      },
      {
        path: 'notifications',
        component: NotificationTemplateListComponent,
        canDeactivate: [canDeactivateGuard],
        data: { breadcrumb: 'Notification Templates' },
      },
      {
        path: 'user-accounts',
        component: UserAccountsComponent,
        data: { breadcrumb: 'Access' },
      },
      {
        path: 'proximity-api',
        component: ProximityApiComponent,
        canDeactivate: [canDeactivateGuard],
        data: { breadcrumb: 'Proximity API' },
      },
      {
        path: 'qbo-test',
        component: QboTestComponent,
        data: { breadcrumb: 'QBO Test' },
      },
      {
        path: 'qb-audit',
        component: QbAuditComponent,
        data: { breadcrumb: 'QuickBooks Audit' },
      },
      {
        path: 'qb-config',
        component: QbConfigComponent,
        data: { breadcrumb: 'QBO Account Setup' },
      },
      {
        path: 'order-analysis',
        component: OrderAnalysisComponent,
        data: { breadcrumb: 'Order Analysis' },
      },
      {
        path: 'manufacturer-feed',
        component: StagedFeedComponent,
        data: { breadcrumb: 'Manufacturer Feed' },
      },
      {
        path: 'hangfire-jobs',
        component: HangfireJobsComponent,
        data: { breadcrumb: 'Hangfire Jobs' },
      },
      {
        path: 'utilities/stranded-orders',
        component: StrandedOrdersComponent,
        data: { breadcrumb: 'Stranded Job Orders' },
      },
      {
        path: 'utilities/enable-account-inventory',
        component: EnableAccountInventoryComponent,
        data: { breadcrumb: 'Enable Account Inventory' },
      },
      {
        path: 'docs/auto-notes-catalog',
        component: AutoNotesCatalogDocComponent,
        data: { breadcrumb: 'Auto-Notes Catalog' },
      },
      {
        path: 'docs/unwind-and-reconciliation',
        component: UnwindAndReconciliationDocComponent,
        data: { breadcrumb: 'Unwind & Reconciliation' },
      },
    ],
  },
  {
    path: 'accounts',
    component: AccountComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    data: {
      icon: 'business'
    }
  },
  {
    path: "restock-fee-invoice/:accountId",
    component: RestockFeePrintableComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { title: "Restock Fee Invoice" },
  },

];


@NgModule({
  declarations: [
    UserAccountsComponent,
    UserAccountDialogComponent,
    AppConfigDialogComponent,
    TextboxDialogComponent,
    TextPromptDialogComponent,
    AccountFinderDialogComponent,
    JobOrderFinderDialogComponent,
    EditAccountDialogComponent,
    QboCustomerLinkDialogComponent,
    RestockFeeDialogComponent,
    RestockFeeInvoiceComponent,
    RestockFeePrintableComponent,
    AccountComponent,
    QbConfigComponent,
    QbAuditComponent,
    QboTestComponent,
    AdministrationManagerComponent,
    OrderAnalysisComponent,
    HangfireJobsComponent,
    AutoNotesCatalogDocComponent,
    UnwindAndReconciliationDocComponent,
    EnableAccountInventoryComponent,
    StrandedOrdersComponent,
    StagedFeedComponent,
    BulkRepointColorDialogComponent,
    BulkRetireDialogComponent,
  ],
  imports: [
    SharedModule,
    MarkdownModule.forChild(),
  ],
  exports: [

  ],
})

export class AdminModule {
}
